import apiV2 from '../../../api-v2';
import personApi from '../../../api/person/PersonApi';
import systemBalanceActionType from '../../constants-v2/crm/system-balance-action-type';
import HttpBuildQuery from '../../procedures/http-build-query';
import iterateObject from '../../procedures/iterate-object';
import promiseAllSettled from '../../procedures/promise-all-settled';
import FiltersType from './listingFiltersTypesConstants';

export default {
  path: '/system-balances',
  filters: [
    {
      key: 'fulltext',
      placeholder: 'Wpisz frazę do znalezienia',
      shortPlaceholder: 'Szukaj',
      badge: 'Szukana fraza:',
      testName: 'hub_filter_search',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
      reset: async () => ({ value: '' }),
    },
    {
      key: '_action_type',
      getItems: async () => iterateObject(systemBalanceActionType.dictionary).map(({ label, value }) => ({ label, value })),
      reset: async () => null,
      placeholder: '',
      badge: 'Rodzaj operacji:',
      testName: 'test_filter_system_balance_action_type',
      inputType: FiltersType.MULTI_SELECT_TYPE,
    },
    {
      key: '_editor',
      getItems: async () => {
        const results = await promiseAllSettled([
          personApi.getBoss(),
          apiV2.staff.staff.list(HttpBuildQuery({ list: true })),
        ]);

        const editors = [];

        if (results[0].ok) {
          editors.push({ value: results[0].data.original, label: `Właściciel: ${ results[0].data.name } ${ results[0].data.surname }` });
        }

        if (results[1].ok) {
          delete results[1].data.pagination;
          editors.push(...Object.values(results[1].data).map(e => ({
            value: e.employee.person.original,
            label: `${ e.employee.person.name } ${ e.employee.person.surname }`,
          })));
        }

        return editors;
      },
      reset: async () => null,
      placeholder: '',
      badge: 'Edytor:',
      testName: 'test_filter_system_balance_editor',
      inputType: FiltersType.MULTI_SELECT_TYPE,
    },
    {
      key: '_created_at',
      reset: async () => ({ value: { fromVal: null, toVal: null } }),
      placeholder: '',
      badge: 'Data operacji:',
      testName: 'test_filter_system_balance_created_at',
      inputType: FiltersType.RANGE_TYPE,
      htmlInputType: 'date',
    },
    {
      key: '_change_absolute_value',
      reset: async () => ({ value: { fromVal: null, toVal: null } }),
      placeholder: '',
      badge: 'Kwota operacji:',
      testName: 'test_filter_system_balance_change',
      inputType: FiltersType.RANGE_TYPE,
      htmlInputType: 'number',
    },
  ],
};
